// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"08d6bdcc","288":"4a4e060c","642":"eaceb507","929":"91c30bfa"}[chunkId] + ".chunk.js";
};